import { maskEmail } from "../lib/mask";


const EMOJIS = [
  { emoji: "❤️", key: "heart" },
  { emoji: "👍", key: "thumbs" },
  { emoji: "😍", key: "love" },
];

export const EntryReactions = ({ reactions = [], entryId, onToggle, myEmail }) => (
  <div className="flex items-center gap-1.5 mt-2.5" data-testid={`entry-reactions-${entryId}`}>
    {EMOJIS.map(({ emoji, key }) => {
      const list = reactions.filter((r) => r.emoji === emoji);
      const mine = myEmail && list.some((r) => r.author_email === myEmail || r.author_email === maskEmail(myEmail));
      return (
        <button key={key} data-testid={`reaction-${key}-${entryId}`} disabled={!onToggle}
          onClick={() => onToggle?.(emoji)}
          title={list.map((r) => r.author_name).join(", ")}
          className={`rounded-full px-2.5 py-1 text-sm leading-none flex items-center gap-1 border active:scale-90 transition-[background-color,border-color,transform] duration-200 ${
            mine ? "bg-[#B5838D]/15 border-[#B5838D]/50" : "bg-secondary/60 border-transparent"
          } ${onToggle ? "hover:border-[#B5838D]/40 cursor-pointer" : "cursor-default"}`}>
          <span>{emoji}</span>
          {list.length > 0 && <span data-testid={`reaction-count-${key}-${entryId}`} className="text-xs font-semibold font-mono">{list.length}</span>}
        </button>
      );
    })}
  </div>
);
